export default __webpack_public_path__ + "static/media/pay_on_line.bbe0a553.png";